import React, { Component, PureComponent } from 'react';
import _ from '../../i18n.jsx';
import ld from 'lodash';

import { setFieldValue, resetFieldValue } from '../../app.reducer.jsx';
import { initPersonsArray, changePersonsArray } from './reducer.jsx';
import { bindActionCreators } from '../../app.store.jsx';
import { MALE, FEMALE, getRelationName, schemaMap, FIRST_CAP_CASE, COUSIN } from '../../engine/persons.schemas.jsx';
import { isEmptyValue } from '../../../common/utils.jsx';
import fieldMap from '../fields.map.jsx';
import style from './persons.array.less';
import RelativeType from '../relative.type.control/relative.type.control.jsx';
import { getPropsOrDefault, holdInRange, isNumberKeyCode, isNavigationKey, isRemoveKey, isFunctionalKey, compareObjectsInclusive, KEY_CODES } from '../../../common/utils.jsx';
import classNames from 'classnames';
import { EMPTY_STRING, EMPTY_ARRAY, EMPTY_OBJECT, SINGLE_SPACE } from '../../questionnaire.utils.jsx';


export class PersonCounter extends PureComponent {
    constructor() {
        super();
        this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.increaseValue = this.increaseValue.bind(this);
        this.decreaseValue = this.decreaseValue.bind(this);
    }

    onKeyDownHandler(event) {
        const keyCode = event.keyCode;
        const isNum = isNumberKeyCode(keyCode);
        const isRemove = isRemoveKey(keyCode);
        if (keyCode === KEY_CODES.ARROW_DOWN) {
            this.decreaseValue();
            event.preventDefault();
        } else if (keyCode === KEY_CODES.ARROW_UP) {
            this.increaseValue();
            event.preventDefault();
        }
        if (isNavigationKey(keyCode) || isFunctionalKey(keyCode)) { return; }
        if ((!isNum && !isRemove) || event.shiftKey) { event.preventDefault(); }
    }
    onChangeHandler(event) {
        const inputValue = parseInt(event.target.value) || 0;
        const currentValue = this.props.value;
        const newValue = holdInRange(inputValue, 0, PersonCounter.MAX_VALUE);
        this.props.onChangeCallback(this.props.gender, newValue - currentValue);
    }
    increaseValue() {
        const syntheticEvent = { target: { value: this.props.value + 1 } };
        this.onChangeHandler(syntheticEvent);
    }
    decreaseValue() {
        const syntheticEvent = { target: { value: this.props.value - 1 } };
        this.onChangeHandler(syntheticEvent);
    }
    render() {
        const { label, value, id, disabled } = this.props;
        return (
            <div className={style.counterOuterWrapper}>
                <div className={style.counterInnerWrapper}>
                    <label forhtml={id} className={style.label}>{label}</label>
                    <input disabled={disabled} type="text" className={style.input} value={value} onKeyDown={this.onKeyDownHandler}
                        onChange={this.onChangeHandler}/>
                    <button disabled={disabled} className={PersonCounter.STYLE.BTN_PLUS_CLASS} onClick={this.increaseValue}>
                        <i className={PersonCounter.STYLE.ICON_PLUS_CLASS}></i>
                    </button>
                    <button disabled={disabled} className={PersonCounter.STYLE.BTN_MINUS_CLASS} onClick={this.decreaseValue}>
                        <i className={PersonCounter.STYLE.ICON_MINUS_CLASS}></i>
                    </button>
                </div>
            </div>
        );
    }
}
PersonCounter.MAX_VALUE = 10;
PersonCounter.STYLE = {
    BTN_MINUS_CLASS: classNames(style.btn, style.btnMinus),
    BTN_PLUS_CLASS: classNames(style.btn, style.btnPlus),
    ICON_MINUS_CLASS: classNames(style.icon, style.iconMinus),
    ICON_PLUS_CLASS: classNames(style.icon, style.iconPlus)
};

export class SchemaFormField extends Component {
    shouldComponentUpdate(nextProps) {
        /*
        * Static props (shouldn't change in time):
        * id, name, root, title, inputType, condition, schemaName
        * Dynamic props:
        * props, fieldValues, localValues, components, personId, disabled
        * */
        const localFieldAreChanged = !ld.isEqual(this.props.localValues, nextProps.localValues);
        if (localFieldAreChanged) { return true; }

        const globalFieldAreChanged = !ld.isEqual(this.props.fieldValues, nextProps.fieldValues);
        if (localFieldAreChanged) { return globalFieldAreChanged; }

        return compareObjectsInclusive(this.props, nextProps, [ 'personId', 'disabled', 'props', 'components' ]);
    }
    render() {
        const { name, root, title, inputType, props, fieldValues, localValues, condition, components, schemaName, personId, disabled } = this.props;
        let isOpen = true;
        if ('function' === typeof condition) { isOpen = condition(fieldValues, localValues); }
        if (!isOpen) { return null; }
        if (isEmptyValue(name)) { throw new TypeError(`SchemaFormField class error: invalid field name: ${name}`); }
        if (undefined === fieldMap[inputType]) { throw new TypeError(`SchemaFormField class error: unknown field type: ${inputType}`); }
        const ReactField = fieldMap[inputType];
        const id = this.props.id || `${root}-${name}`.replace(/\s/g, EMPTY_STRING);
        return isOpen ? (
            <div>
                { title }
                <ReactField cssButtonClass={style.button} cssDropdownClass={style.dropdown} components={components} cssClassWrapper={style.dropdownWrapper}
                            schemaName={schemaName} id={id} name={name} root={root} value={localValues[name]} disabled={disabled}
                            localValues={localValues} fieldValues={fieldValues} componentName={`${id}-${personId}`} {...props}/>
            </div>
        ) : null;
    }
}

export class SchemaForm extends PureComponent {
    constructor() {
        super();
        this.resetFieldValue = this.resetFieldValue.bind(this);
        this._setFieldValue = bindActionCreators(setFieldValue);
        this._resetFieldValue = bindActionCreators(resetFieldValue);
    }

    resetFieldValue() {
        const path = this.props.root.split(SINGLE_SPACE);
        const name = path.pop();
        this._resetFieldValue(name, path.join(SINGLE_SPACE));
    }
    render() {
        const { schema, root, gender, submit, components, personId, disabled } = this.props;
        const localValues = this.props.localValues || EMPTY_OBJECT;
        const fieldValues = this.props.fieldValues || EMPTY_OBJECT;
        const tabIndex = disabled ? -1 : 0;
        return (
            <div className={classNames(style.personForm, { [style.personFormOpened]: submit })} tabIndex={tabIndex}>
                <RelativeType disabled={disabled} relationship={schema.relationType} name={schema.name} gender={gender} root={root}
                              localValues={localValues} fieldValues={fieldValues} personId={personId} parentRequired={schema.parentRequired}/>
                <div className={style.btnDelete} onClick={this.resetFieldValue}>
                    <a className={style.iconDelete}></a>
                </div>
                {
                    submit
                    ? <div className={style.personFieldsContainer}>
                        {
                            schema.fields.map((field, index) => <SchemaFormField disabled={disabled} key={index} {...field} root={root} personId={personId}
                                schemaName={schema.name} localValues={localValues} fieldValues={fieldValues} components={components}/>
                            )
                        }
                    </div>
                    : null
                }
            </div>
        );
    }
}


export class SchemaFormsBuilder extends Component {
    constructor() {
        super();
        this.generateListFromScratch = this.generateListFromScratch.bind(this);
        this.generateListFromData = this.generateListFromData.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        return compareObjectsInclusive(this.props, nextProps, [ 'femaleCount', 'maleCount', 'disabled', 'name', 'submit' ])
                || !ld.isEqual(this.props.localValues, nextProps.localValues)
                || !ld.isEqual(this.props.fieldValues, nextProps.fieldValues)
                || !ld.isEqual(this.props.components, nextProps.components);
    }
    generateListFromScratch(fromIndex, toIndex, gender) {
        const { name, schema, submit, components, disabled } = this.props;
        const localValues = this.props.localValues || EMPTY_OBJECT;
        const fieldValues = this.props.fieldValues || EMPTY_OBJECT;
        const formsList = [];
        for (let formNumber = fromIndex; formNumber < toIndex; formNumber++) {
            const root = `${name} data ${formNumber}`;
            const formValues = localValues[formNumber];
            formsList.push(
                <SchemaForm disabled={disabled} root={root} name={name} schema={schema} localValues={formValues} fieldValues={fieldValues}
                            gender={gender} key={formNumber} submit={submit} personId={formNumber} components={components}/>
            );
        }
        return formsList;
    }
    generateListFromData() {
        const { name, schema, submit, components, disabled } = this.props;
        const localValues = this.props.localValues || EMPTY_OBJECT;
        const fieldValues = this.props.fieldValues || EMPTY_OBJECT;
        const formsList = [];
        const formsKeys = Object.keys(localValues);
        formsKeys.forEach((formNumber) => {
            const root = `${name} data ${formNumber}`;
            const formValues = localValues[formNumber];
            const gender = formValues.gender;
            formsList.push(
                <SchemaForm disabled={disabled} root={root} name={name} schema={schema} localValues={formValues} fieldValues={fieldValues}
                            gender={gender} key={formNumber} submit={submit} personId={formNumber} components={components}/>
            );
        });
        return formsList;
    }
    generateFormList() {
        const { maleCount, femaleCount } = this.props;
        const localValues = this.props.localValues || EMPTY_OBJECT;
        const formsKeys = Object.keys(localValues);
        if (0 < formsKeys.length) { return this.generateListFromData(); }
        const femaleList = this.generateListFromScratch(0, femaleCount, FEMALE);
        const maleList = this.generateListFromScratch(femaleCount, femaleCount + maleCount, MALE);
        return femaleList.concat(maleList);
    }
    render() {
        return <div> { this.generateFormList() } </div>;
    }
}


export default class PersonsArray extends Component {
    constructor() {
        super();
        this.inputChangeCallback = this.inputChangeCallback.bind(this);
        this.increaseValue = this.increaseValue.bind(this);
        this.addFemale = this.addFemale.bind(this);
        this.addMale = this.addMale.bind(this);
        this.getPersonsCount = this.getPersonsCount.bind(this);
        this._initPersonsArray = bindActionCreators(initPersonsArray);
        this._setFieldValue = bindActionCreators(setFieldValue);
        this._changePersonsArray = bindActionCreators(changePersonsArray);
    }
    static _validGenderOrThrow(gender) {
        if (MALE !== gender && FEMALE !== gender) {
            throw new Error('PairedCounter: inputChangeCallback() unknown gender value');
        }
    }
    static _matchGender(gender) {
        return (person) => {
            PersonsArray._validGenderOrThrow(person.gender);
            return gender === person.gender;
        };
    }
    static _displayStyle(value) { return { display: value ? 'block' : 'none' }; }
    shouldComponentUpdate() {
        return true;
        //return compareObjectsInclusive(this.props, nextProps, [ 'name', 'schemaName', 'disabled' ])
        //        || !ld.isEqual(this.props.components.personsArrays, nextProps.components.personsArrays)
        //        || !ld.isEqual(this.props.fieldValues, nextProps.fieldValues);
    }
    increaseValue(gender) {
        this._changePersonsArray(this.props.name, gender, 1);
    }
    addFemale() { this.increaseValue(FEMALE); }
    addMale() { this.increaseValue(MALE); }
    inputChangeCallback(gender, difference) {
        PersonsArray._validGenderOrThrow(gender);
        this._changePersonsArray(this.props.name, gender, difference);
    }
    componentDidMount() {
        if (undefined === this.props.value) {
            this._initPersonsArray(this.props.name);
        }
    }
    getPersonsCount() {
        const values = getPropsOrDefault(this.props, 'value.data', {});
        const personsKeys = Object.keys(values);
        const personsArray = personsKeys.map((key) => values[key]);
        /*
         * WT-4936 - this check is to avoid crash questionnaire if GENDER field is missed in
         * person object of personsArray.
         * Initialize it as MALE by default if this field is missed.
         * */
        /* eslint-disable no-process-env */
        if ('production' === process.env.NODE_ENV) {
        /* eslint-enable no-process-env */
            if (!ld.every(personsArray, 'gender')) {
                ld.forEach(personsArray, (person) => {
                    if (!person.gender) { person.gender = MALE; }
                });
            }
        }
        const maleCount = personsArray.filter(PersonsArray._matchGender(MALE)).length;
        const femaleCount = personsArray.length - maleCount;
        return { male: maleCount, female: femaleCount };
    }
    render() {
        const { name, schemaName, fieldValues, components, disabled } = this.props;
        const schema = schemaMap[schemaName];
        const maleSingle = getRelationName(schemaName, MALE, FIRST_CAP_CASE);
        const femaleSingle = getRelationName(schemaName, FEMALE, FIRST_CAP_CASE);
        const malePlural = COUSIN !== schemaName ? _(`${maleSingle}s`) : _(`${maleSingle}s (male)`);
        const femalePlural = COUSIN !== schemaName ? _(`${femaleSingle}s`) : _(`${femaleSingle}s (female)`);
        const submit = getPropsOrDefault(this.props, `value.submit`, false);
        const { male: maleCount, female: femaleCount } = this.getPersonsCount();
        const localValues = getPropsOrDefault(this.props, `value.data`, EMPTY_ARRAY);
        const addFemaleBtnLabel = COUSIN !== schemaName ? _(`Add ${femaleSingle}`) : _(`Add ${femaleSingle} (female)`);
        const addMaleBtnLabel = COUSIN !== schemaName ? _(`Add ${maleSingle}`) : _(`Add ${maleSingle} (male)`);
        return (
            <div className={style.wrapper}>
                {
                    !submit
                    ? <div className={style.innerWrapper}>
                        <PersonCounter disabled={disabled} label={femalePlural} value={femaleCount} gender={FEMALE}
                                       onChangeCallback={this.inputChangeCallback}/>
                        <PersonCounter disabled={disabled} label={malePlural} value={maleCount} gender={MALE}
                                   onChangeCallback={this.inputChangeCallback}/>
                    </div>
                    : null
                }
                <div className={style.personsContainer}>
                    <SchemaFormsBuilder disabled={disabled} localValues={localValues} name={name} schema={schema} submit={submit}
                                        femaleCount={femaleCount} maleCount={maleCount} fieldValues={fieldValues}
                                        components={components}/>
                </div>
                {
                    submit
                    ? <div className={style.addRelativeBlock}>
                        <button disabled={disabled} className={style.addRelativeBtn} onClick={this.addFemale}>
                            {addFemaleBtnLabel}
                        </button>
                        <button disabled={disabled} className={style.addRelativeBtn} onClick={this.addMale}>
                            {addMaleBtnLabel}
                        </button>
                    </div> : null
                }
            </div>
        );
    }
}
